// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/MagicPatterndesign.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
button.burgermenu {
    display: none;
}
button.menu-btn.back {
    display: none;
}
.sidebarWraper {
    height: 100% !important;
}

/* LOGIN-DESIGN START */
.login-box .topParts {
    padding: 3px 0 0 0;
}
.login-box h2 {
    color: #302B3A;
    font-size: 24px;
    font-weight: 600;
    margin: 10px 0;
    padding: 0;
}

.login-box h4 {
    color: #666666;
    font-size: 15px;
    font-weight: 500;
    margin: 10px 0 5px;
    padding: 0;
}
.login_container .loginForm .form-control {
    border-radius: 10px;
    min-height: 45px;
}
.login_bg .alignBx {
    display: flex;
    align-items: center;
    height: 100%;
    justify-content: center;
}
.loginHeader {
    padding: 15px;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 10;
    background: #FFF;
    border-bottom: 1px solid #DFDFDF;
    height: auto;
    min-height: 79px;
}
.loginHeader .container-fluid{
    padding-left: 7.5px;
    padding-right: 7.5px;
}
.login_logo .logo_Img  {
    max-width: 135px;
}
 .login_bg{
    padding: 0px;
    height: 100%;
    margin-top: 70px;
}
.bgOuter .leftBg {
      float: left;
      width: calc(100% - 587px);
      padding: 15px 5%;
      height: calc(100vh - 70px );
      background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
      background-repeat: no-repeat !important;
      background-size: cover !important;
}
.bgOuter .rightBg {
    width: 587px;
    float: right;
    max-width: 100%;
    background: #F8F8F8;
    height: calc(100vh - 70px );
    padding: 15px 5%;
}
.sliderWrapper .sliderImg .sliderImg {
    max-width: 100%;
    max-height: 400px;
    width: auto;
    object-fit: cover;
    margin: 0 auto;
}
.sliderWrapper .sliderCont .slide_title {
    color: #302B38;
    font-size: 16px;
    font-weight: 600;
    margin: 20px 0 10px;
}
.sliderWrapper .sliderCont .slide_des {
    color: #666666;
    font-size: 15px;
    font-weight: 500;
    line-height: 20px;
    margin: 0 0 5px;
}
.login-box .frgPasrd {
    color: #666666;
    font-size: 15px;
    font-weight: 500;
}
.login-box input.form-control {
    height: 45px;
    border: 1px solid #DFDFDF;
    border-radius: 10px;
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
}
button.btn.eye-bttn {
    border:1px solid #DFDFDF;
    background: white;
    border-radius: 0px;
    border-bottom-right-radius: 12px;
    border-top-right-radius: 12px;
    border-left: none;
    margin-left: -10px;
}


input.form-control.inputs-radus {
    border-bottom-right-radius: 12px;
    border-top-right-radius: 12px;
}
.loginHeader .login_link a {
    color: #302B3A;
    font-size: 15px;
    font-weight: 500;
}
/* .login-box .Auth_button__wLxLD{ margin: 0 !important; } */

.rightBg .sliderWrapper {
    padding: 5px;
}
.login-box button.btn.btn-primary {
    height: 50px;
    background: #3A68D8;
    font-size: 15px !important;
    font-weight: 700;
    border-radius: 10px;
    margin-bottom: 0rem !important;
    margin-top: calc(2rem - 10px) !important;
    line-height: 1.5;
    border: 1px solid transparent;
    cursor: pointer !important;
}

.login-box ul.dropdown-menu.show {
    right: 0 !important;
    left: inherit !important;
    transform: translate3d(0px, 30px, 0px) !important;
    width: auto;
    min-width: 120px;
    padding: 3px 0;
    border: 1px solid #DFDFDF;
}
.login-box .topParts .dropdown-item:hover, .login-box .topParts .dropdown-item:focus{
    background: transparent;
}




.login-box .paddingSp .form-group.mb-3{ margin: 1.5rem 0 1rem; }

/* .login-box .Auth_button__JNDtr{margin: 0 !important; } */

.bgOuter .login-box .form_Header{
    margin-bottom: 0;
}
.bgOuter .login-box .login-logo{ margin-bottom: 0.9rem; }

.bgOuter .login-box .logo_Img{     
    max-width: 135px;
}
.login-box .topParts .dropdown-toggle{
    white-space: nowrap;
    background-color: transparent !important;
    border: 0 !important;
    color: #666666 !important;
    font-size: 15px;
    padding: 0;
    font-weight: 500;
}
.login-box .topParts .dropdown-item{
    color: #666666 !important;
    font-size: 15px;
    font-weight: 500;
}
.login-box .container.form.paddingSp{
    max-width: 100%; 
    width:100%;
    padding: 0;
}

.login_bg .login-box{
    max-width: 100%;
    width: 650px;
    display: inline-table;
    text-align: left;
    border: 1px solid #DFDFDF;
    border-radius: 20px;
    padding: 2rem;
    background: #FFF;
}



@media (max-width: 640px) {
    iframe.frame-view {
        width: 100%;
        height: 280px;
    }
}

@media (max-width: 580px) {
    li.list-group-item.bordes-div {
        border: 1px solid #DFDFDF;
        border-radius: 10px !important;
        background-color: #FFF;
        overflow: hidden;
        min-height: 100px;
        margin: 10px 0px 19px 0px;
        padding: 2px 0px 0px 20px;
    }
}

  

img.menu_icon.search.res-icon {
    position: absolute;
    left: 8px;
    top: 13px !important;
    width: 15px;
}

.searchere.mb-0.serach-div.resours-div {
    align-items: center;
    border-radius: 10px;
    border: 1px solid var(--light-gray-outline, #DFDFDF);
    background: #FFF;
    height: 40px;
    justify-content: flex-end;
    display: flex;
    margin-top: 7px;
    float: right;
    position: relative;
    width: 321px;
    max-width: 100%;
    margin-right: 21px;
}
p.form-name.res-tittle.my-1 {
    color: #3A68D8;
    font-weight: 600;
    text-decoration: underline;
    font-size: 15px;
    cursor: pointer;
}
.search.serach-width-div.res-div.col-md-4 {
    position: relative;
    width: 380px;
    max-width: 100%;
    float: right;
}

    li.list-group-item.bordes-div {
        border: 1px solid #DFDFDF;
        border-radius: 10px !important;
        background-color: #FFF;
        overflow: hidden;
        height: 61px;
        margin: 10px 0px 19px 0px;
        padding: 2px 0px 0px 20px;
    }
       
      


















/* 
@media screen and (max-height: 2100px){
    .d-flex.detail-user, .can-lists {
        min-height: 71vh !important;
    }
} */


@media screen and (max-width: 1040px) {
    .sidebarWraper {
        height: 100%;
    }
    nav.sidebar {
        padding: 0px 10px;
    }
    .sidebar {
        height: 100%;
        width: 214px}

    span.menu-title {
        display: none;
    }
    nav.sidebar{
        width: 85px !important;
        padding: 0px 10px;
     }
    nav.sidebar.active {
        /* width: 35%; */
        width: 85px;
        padding: 0px 10px;
    }
    .mainHeader {
        width: calc(100% - 85px) !important;
        position: fixed !important;
        z-index: 999 !important;
        right: 0 !important;
        top: 0 !important;
    }
    .sidebar_open.fixed-side {
        padding: 111px 20px 20px 111px !important;
        margin: 0;
    }

    .logoContainer {
        width: 62px;
        overflow-x: hidden;
        pointer-events: none;
    }
    .sidebar ul.nav .accordion-button, .sidebar ul.nav a.nav-link {
        justify-content: center;
    }
    .sidebar a.nav-link.active::before {
        border-left: 3px solid var(--color1);
        content: ' ';
        position: absolute;
        left: -10px;
        top: 0;
        height: 100%;
        z-index: 1;
    }
    .logoContainer img {
        width: 70px;
        height: 45px;
        object-fit: none;
        object-position: 10px 0px;
    }
    .ht-box .content-sc, .ht-box .sidebar_open {
        padding: 60px 20px 20px 20px !important;
        margin: 0;
    }
    /* .sidebar.active a.nav-link.active::before {
        left: -25px;
    } */
    .Auth_form__IOjvb {
        box-shadow: none;
    }
    .Auth_form__IOjvb h3 {
        font-weight: bold;
        font-size: 30px;
    }
    .Auth_form__IOjvb input.form-control {
        border: 1px solid #ccc;
        padding: 10px 16px !important;
        margin-top: 5px;
    }
    .Auth_form__IOjvb input.form-control::placeholder {
        font-size: 14px;
    }
        

}

@media(max-width: 991px){

    .login_bg  .leftBg { float: left;  width: 60%; } 
    .login_bg  .rightBg { float: left;  width: 40%; }

    .sideCont .sidebarFixs{ width: 22%; }
    

}
@media screen and (max-width: 767px) {
    
    .candPrv .logo-sec{ margin: 0 !important; }
    .login_bg { margin-top: 70px;  }
    .login_bg  .leftBg,  .login_bg  .rightBg { float: left;  width: 100%; height: auto;  padding: 2rem; } 
    .thanku-cards{ width: 93% !important; }
    .thanku-cards .card-1 { padding: 35px; }
    .sideCont .sidebarFixs{position: relative; max-width: 100%;  width: 100%; }
    .e-toolbar-items.e-tbar-pos .e-toolbar-center {  margin: 0 !important; }
    .e-toolbar .e-toolbar-items.e-tbar-pos .e-toolbar-right { float: right;  }
    .e-control.e-toolbar.e-lib.e-keyboard {  border: 1px solid #e8e8e8; border-bottom: 0; width: 100% !important; }
    .cardPost {  position: relative; bottom: 0; left: 0; }
    .welcome-text {font-size: 28px;  line-height: 28px; }
    .padd-review-page .rev-padd-tap button.confirm-btn{ margin: 0 10px 10px 0; }
    .rightCont .collap-head .alignHead_review .task-count, .rightCont .action-itms.full-drp.flex-column .d-flex.justify-content-between .task-count{ justify-content: end;  }
    .padd-review-inner .alignHead_review .hd-can-review.create-form-wrp.newPad {  width:100%;}
    .rightCont .collap-head .alignHead_review, .rightCont .action-itms.full-drp.flex-column .d-flex.justify-content-between{ /*flex-direction: column-reverse;*/ flex-direction: row; padding: 10px;}
    .rightCont .collap-head .alignHead_review .hd-can-review.create-form-wrp.newPad.alig_cent, .rightCont .action-itms.full-drp.flex-column .d-flex.justify-content-between .hd-can-review.neSp.create-form-wrp {  width: 100%; }
    .rightCont .padd-review-inner.collap-head .alignHead_review{ flex-direction: row; }
    .rightCont .action-itms button.select-btn { padding-right: 0; }

 
    .Auth_form__IOjvb {
        box-shadow: none;
    }
    .Auth_form__IOjvb h3 {
        font-weight: bold;
        font-size: 30px;
    }
    .Auth_form__IOjvb input.form-control {
        border: 1px solid #ccc;
        padding: 10px 16px !important;
        margin-top: 5px;
    }
    .Auth_form__IOjvb input.form-control::placeholder {
        font-size: 14px;
    }
    button.btn.btn-primary.btn-block.w-100.mt-4 {
        font-size: 20px;
    }
    .mainWrap header.mainHeader {
        width: 100% !important;
    }
    .mainWrap .content-sc, .mainWrap .sidebar_open {
        padding: 60px 20px 5px 20px ;
        margin: 0 !important;
    }
    header {
        height: 60px;
    }
    .ht-box {
        margin-top: 50px;
    }
    .col-md-8.col-lg-9.candPads {
        display: none;
    }
    .men-btn.d-flex.align-items-center {
        width: -moz-fit-content;
        width: fit-content;
        justify-content: flex-start;
        flex-direction: row !important;
        overflow-x: scroll;
        margin-top: 8px;
    }
    button.status-btn {
        margin-right: 5px !important;
        min-width: inherit !important;
    }
    .action-itms.ac-spaceBt.d-flex.align-items-center.justifycontent-between.px-3 {
        margin-top: 12px;
    }
    .searchere img {
        width: 18px !important;
        top: 20px !important;
    }

    .tables.docTable {
        overflow: scroll;
    }
    .searchere input::placeholder {
        font-size: 17px;
        padding-left: 10px;
    }
    .userarea {
        display: block;
    }
    button.burgermenu {
        display: block;
    }
    button.burgermenu {
        background: #fff;
        border: 1px solid #ccc;
        font-size: 14px;
        padding: 6px 10px;
    }
    nav.sidebar {
        position: fixed;
        left: -290px;
    }
    nav.sidebar.active {
        position: fixed;
        left: 0px;
        top: -60px;
        width: 15% !important;
        border: 1px solid #ccc;
        /* height: auto !important; */
    }
    /*nav.sidebar.active {
        position: fixed;
        left: -20px;
        top: -50px; }*/
   
    .collapseView .content-sc, .collapseView .sidebar_open {
        padding: 50px 20px 20px 58px !important;
        margin-left: 10px !important;
    }
    .searchere.mb-0 {
        margin-top: 15px;
    }
    .logoContainer img {
        width: 110px;
        height: 25px;
        margin-top: 50px;
    }
    .collapseView header.mainHeader {
        width: 100% !important;
    }
    .footer_collapse.mt-2 p {
        width: -moz-fit-content;
        width: fit-content;
        color: #fff;
    }
    .col-md-8.col-lg-9.candPads.active {
        display: block;
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        padding: 0;
        z-index: 999;
    }
    .d-flex.detail-user {
        min-height: 100%;
        border-radius: 0px !;
    }
    .llbw {
        flex-direction: column;
    }
    .llbw .candidate {
        width: 100%;    
        margin-bottom: 20px;
    }
    .detail-tabs ul.react-tabs__tab-list {
        display: flex;
        overflow-x: auto;
    }
    .detail-tabs .react-tabs__tab {
        white-space: nowrap;
    }
    span.username {
        display: none;
    }
    .llbw .avatar {
        background-color: var(--color1) !important;
        min-width: 60px;
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 8px;
    }
    .llbw .avatar p{
        color: #fff !important;
    }
    .llbw .ca-details {
        width: 100%;
        margin-left: 10px;
    }
    .llbw  .ca-details h3 {
        margin-bottom: 0px;
        font-size: 15px !important;
    }
    .filterAlign {
        width: 100%;
        padding: 10px;
        margin-top: 10px;
    }
    .candPads {
        padding: 5px 18px 3px 4px !important;
        margin-left: 8px;
    }


    .form-select.drop-filter.customFilt.select-box {
        height: 40px;
        overflow-y: auto;
        width: 100% !important;
    }

    .sidebar a.nav-link.active {
        color: #FFF;
        /* border-left: 3px solid #3A68D8; */
        font-weight: 500;
        background: linear-gradient(90deg, #3A68D8 0%, rgba(58, 104, 216, 0.00) 100%, rgba(58, 104, 216, 0.00) 100%);
        margin-left: -10px;
    }
    .sidebar .nav a.nav-link {
        /* padding: 0px 10px; */
        /* display: flex; */
        align-items: center;
        /* min-height: inherit; */
        cursor: pointer;
        /* padding-left: 1px !important; */
        /* position: relative; */
        width: 100%;
        padding:15px 10px 15px 10px !important;
    }
    .llbw .ca-details span {
        font-size: 16px;
        margin-bottom: 10px;;
    }
    button.menu-btn.back {
        display: block;
        position: fixed;
        left: 20px;
        top: 15px;
    }
    ul.actn-btns {
        width: 100%;
    }
    .detail-tabs th.firstTab, .detail-tabs td.firstTab {
        min-width: inherit;
        padding-left: 0 !important;
    }
    .onb-actions a, .onb-actions select {
        padding: 8px 12px;
    }
    .team-member select {
        padding: 8px 12px;
    }
    .onb-actions {
        flex-direction: row;
        width: 100%;
        gap: 5px;
    }
    .action-itms-forms.bxShw.px-2.py-4.mb-4 {
        margin-bottom: 5px !important;
        padding-bottom: 7px !important;
    }
    .f-itm {
        flex-direction: row;
        align-items: center;
    }
    button.Save {
        margin-top: 10px;
        width: 100%;
        margin-bottom: 40px;
    }

    .sub-acc.blueborder.newBorder {
        border-radius: 10px;
    }
    .wraper.listTmplt {
        display: flex;
        align-items: center;
    }
    .icon-dele {
        margin-top: inherit !important;
    }
    .icon-dele {
        margin-top: inherit !important;
        background: #cccccc6e;
        width: 35px;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 35px;
        border-radius: 5px;
    }
    .sub-acc.padSpace {
        margin-top: 10px;
    }
    .ReactModal__Content.ReactModal__Content--after-open {
        width: 100% !important;
        transform: translate(0%, 0%) !important;
        max-width: 95% !important;
    margin-left: 10px !important;
    }
    .sidebarFixs {
        position: inherit;
        width: 100%;
    }
    .col-lg-10.col-md-9.rightCont {
        margin-top: 25px;
        margin-bottom: 10px;
    }
    .e-toolbar-item button {
        z-index: 99;
    }
    .candPads .alignTops {
        flex-direction: column;
        margin-top: 40px;
    }
    .candPads .alignTops .dropdown, .candPads .alignTops .dropdown button  {
        width: 100%;
    }
    .f-btns .btn {
        width: inherit;
    }

    .footer_collapse {
        z-index: 999;
    }
    .component h6 {
        display: none;
    }
    .sub-acc.h-100.padSpace {
        padding: 15px;
    }
    .alignBox.fn-main ul .boxDiv {
        width: calc(100% / 5);
    }
    .alignBox.fn-main ul li .component {
        min-height: 50px;
    }
    img.create-icon {
        margin-bottom: 0px;
    }

    .row.create-grd .col-lg-6 {
        order: 3;
    }
    div#scrollDiv {
        order: 2 !important;
    }
    ul.MuiList-root.MuiList-padding {
        min-height: 400px !important;
    }
    .d-flex.detail-user {
        border: 0;
    }

    .login-box .login-logo.text-left {
        width: 50%;
        float: left;
    }
    .login-box .topParts .col-sm-4.text-ends {
        width: 50%;
        float: right;
    }
    .switchs {
        position: relative;
        display: flex;
        width: 45px;
        height: 22px;
        margin-left: -5px !important;
    }


}
@media(max-width: 580px){


    .text-padd {
        padding: 10px !important;
    }
    nav.sidebar.active {
        position: fixed;
        left: 0px;
        top: -60px;
        width: 15% !important;
        border: 1px solid #ccc;
        /* height: auto !important; */
    }
    .thanku-cards .card-1 {  padding: 25px 15px; }
    .thanku-sub-heading{  text-align: left !important;}
    .switchs {
        position: relative;
        display: flex;
        width: 45px;
        height: 22px;
        margin-left: -5px !important;
    }

    .task-itms {
        font-size: 15px;
        /* min-width: 100% !important; */
    }
    .line-border {
        width: 100%;
        border-top: 2px solid #F6F6F6;
        margin: 60px 0 0;
    }
    .login_bg .login-box {  padding: 1.5rem;}
    .otp-enter input[type=tel] {
        /*width: 46px !important;
        height: 62px !important;*/  
        max-width: 35px !important;
        max-height: 42px;
        border-radius: 10px !important;
        margin: 0 5px !important;
    }
    .row.px-4.topSpce_view {  padding-right: 0.5rem !important; padding-left: 0.5rem !important; }

    ul.status-ind.viewList a { padding: 5px 10px; }
    .rightCont .action-itms { padding: 10px; }
    .padd-review-page .padd-main {  padding: 0 15px 0px 0px!important; }
    .rightCont .width-flex.w-100.collap-head{ padding: 0; }
    .rightCont .contents-sub.padd-main {  padding: 5px 0; }
    .contents-sub.padd-main .my-0.rev-padd-tap {
        padding: 0 15px 10px;
    }
    .contents-sub.fulWid .btnAlg_same {  margin: 0 10px 10px 0px; }
    .contents-sub.fulWid .btnAlg_same button.confirm-btn{    margin-left: 0; margin-top: 0 !important; }
    .action-itms .contents-sub.fulWid .w-100 >.my-2 {  margin-top: 0rem !important; }
    .padd-review-inner .alignHead_review .hd-can-review.create-form-wrp.newPad {   padding-left: 0; }
    .rightCont .collap-head .alignHead_review .task-count{ margin: 0 !important; }

    .e-toolbar .e-toolbar-item {
        height: inherit;
        min-width: 100%;
        padding: 3.5px;
    }
    .padd-review-page .padd-main {
        margin: 10px 10px 10px 10px!important;
    }
    .video-thumb {
        height: 260px;
        width: 100%;
        border-radius: 15px;
    }
    .img-divs {
        min-width: 100%;
        margin: 0px 0px 0px 6px;
    }
    /* .e-spinner-pane.e-spin-hide {
        display: inline-flex;
        height: 100vh;
    } */
    .e-hscroll .e-hscroll-content {
        width: 100%;
    }
    .thanku-cards {
       width: 95% !important;
    }
    .card-1 {
        padding: 40px;
        text-align: center;
    }
    .filter-main-div {
        display: block;
    }
    .main-filter {
        /* display: flex; */
        /* margin: 0px 15px 0px 0px; 
        height: 65px;*/
        align-items: center;
        width: 100%;
        margin-bottom: 10px !important;
    }
    .welcome-text {
        color: #302b3a;
        color: var(--Avenu-Black,#302b3a);
        font-size: 30px !important;
        font-weight: 700;
        margin: 20px 0;
    }
    
    
}
@media(max-width: 480px){

    .detail-tabs .table tbody.table-text-body td {
        text-wrap: balance;
        min-width: 160px;
    }
    textarea#floatingTextarea {
        height: 20px!important;
        width: 100%!important;
    }

    .logoCent.logo-sec{
       /* left: 45px;*/
        position: fixed !important;
        top: 15px;
        font-size: 18px;
        text-align: center;
    }
    .preview-bck-icon {
        width: 25px;
        top: 0;
        left: 0;
        position: absolute;
        margin: 20px 0px 0px 15px !important;
        z-index: 9999;
        cursor: pointer;
    }
    .sideScroll {
        width: 100%;
        overflow-y: scroll;
        height: auto !important;
        max-height: 100vh;
    }
    .text-padd {
        padding: 10px !important;
    } 
    .rightCont .collap-head .alignHead_review .task-count .progress.custom.me-3 {
        min-width: auto;
        max-width: 120px;
        margin-right: 0 !important;
    }
    .welcome-text {
        color: #302b3a;
        color: var(--Avenu-Black,#302b3a);
        font-size: 30px !important;
        font-weight: 700;
        margin: 20px 0;
    }
    .welcome-text {
        color: #302b3a;
        color: var(--Avenu-Black,#302b3a);
        font-size: 30px;
        font-weight: 700;
        margin: 20px 0;
    }
    .switchs {
        position: relative;
        display: flex;
        width: 45px;
        height: 22px;
        margin-left: -5px !important;
    }
    nav.sidebar.active {
        position: fixed;
        left: 0px;
        top: -60px;
        /*width: 70% !important;*/
        border: 1px solid #ccc;
    }
    nav.sidebar.active .logoContainer h1, nav.sidebar.active span.menu-title, nav.sidebar.active .accordion-button::after {
        display:block; 
        font-size: 15px;
    }
    
    .input-group-append.pass-div-width {
        width: 100% !important;
    }  
    .line-border {
        width: 100%;
        border-top: 2px solid #F6F6F6;
        margin: 60px 0 0;
    }
    .cardPost {
        position: relative !important;
        bottom: 0px !important;
        /* left: 0; */
    }

    .cards.has-text-centered {
        position: relative;
        margin: -40px auto !important;
        width: 800px;
        max-width: 100%;
        min-height: 299px;
        border-radius: 10px;
        border: 0.776px solid var(--light-gray-outline, #DFDFDF);
        background: var(--White, #FFF);
        transform: translate(0%, 30%);
        padding: 15px;
    }
    li.list-group-item.same-line.rigt-alginn {
       /* height: 230px;*/
       height: 185px;
    }
    .first-ul {
        margin-top: 80px  !important;
    }
    .onb-actions {
        flex-direction: column-reverse !important;
        width: 80% !important;
        float: left;
        position: absolute;
        margin: 45px 0px 0px -70px;
    }
    .filter-main-div {
        display: block !important;
    }
    .main-filter {
        /* display: flex; */
        /* margin: 0px 15px 0px 0px;
         height: 65px; */
        align-items: center;
        width: 100%;
    }
    .card-1 {
        padding: 40px;
        text-align: center;
    }
    .alignHead_review, .rightCont .collap-head .alignHead_review {
        justify-content: inherit;
        display: flex;
        width: 100%;
        flex-direction: column;
    }
    .rightCont .collap-head .alignHead_review{ padding: 0;  }

    .alignHead_review .task-itms { text-align: end; /* padding-right: 10px;*/ width: auto; min-width: 120px;  }

    .alignHead_review .hd-can-review h4{ 
        width: 100%;
        background-color: #fff;
        white-space: break-spaces;
        overflow: hidden;
        text-overflow: ellipsis;
        padding-left: 31px;
        margin: 5px 0;
    }
    .over-divz {
        display: none !important;
    }
    .i9-text {
        color: #D15D49;
        font-family: Manrope;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        margin: 7px 0px 0px 10px !important;
        word-break: break-word !important;
    }
    .mobile-over-divz {
        display: flex !important;
    }
    .action-itms .padd-review-inner{
        padding: 10px !important;
        flex-direction: row !important;
        display: flex !important;
        justify-content: flex-start !important; }
    .alignHead_review .hd-can-review h4 > img.create-icon {  margin-left: -30px;}
    .rightCont .collap-head .alignHead_review .task-count {  margin: 0 !important;  width: 100%;  padding: 0;}

    .padd-review-inner .alignHead_review { display: flex; justify-content: space-between; flex-direction: row; }

    .task-count.rev-marg-lft { margin: 0px 10px 0px 0px !important; }

    .rightCont .hd-can-review.newPad { padding-left: 0px !important;  }

    .padd-review-page button.confirm-btn{ margin-left: 0; }

    button.confirm-btn {   margin: 0px 11px 0px 0px; }

    .e-toolbar-item .e-tbar-btn.e-tbtn-txt.e-control#download {
        margin-top: 0px !important;
        min-height: 40px !important;
        min-width: 100%;
        margin-right: 10px !important;
    }
    .e-toolbar .e-toolbar-items .e-toolbar-left, .e-toolbar .e-toolbar-items .e-toolbar-center, .e-toolbar .e-toolbar-items .e-toolbar-right {
        display: contents;
        /* margin: 21px 0px 0px 0px; */
    }

    .e-toolbar .e-toolbar-item {
        height: inherit;
        min-width: 100%;
        padding: 3.5px;
    }

    .inptFiles_up.aligDivs_rev p {
        /* margin: 0; */
        margin: 0px 0px 0px 110px;
        /* max-width: 77%; */
        word-break: break-word;
    }

    /* .e-spinner-pane.e-spin-hide {
        display: inline-flex;
        height: 100vh;
    } */

    .e-hscroll .e-hscroll-content {
        /* display: inline-block; */
        /* height: inherit; */
        /* position: relative; */
        /* margin-left: 21px; */
        width: 100%;
    }
    .login_bg .leftBg, .login_bg .rightBg {  padding: 2rem 1rem; }
  

}

@media(max-width: 320px){

    .login-box .login-logo.text-left {
        width: 100%;
        float: left;
        text-align: center;
        margin-bottom: 5px;
    }
    .login-box .topParts .col-sm-4.text-ends {
        width: 100%;
        float: right;
        text-align: center !important;
        margin-bottom: 10px;
    }
    .login_bg .login-box { padding: 1rem; }
    .login-box h2{ margin-bottom: 0; }
    .login-box h4 {  font-size: 14px; }
    .login-box .frgPasrd {
        width: 100%;
        justify-content: center;
        display: flex;
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/responsive.css"],"names":[],"mappings":";AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,uBAAuB;AAC3B;;AAEA,uBAAuB;AACvB;IACI,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,UAAU;AACd;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,eAAe;IACf,OAAO;IACP,MAAM;IACN,WAAW;IACX,gBAAgB;IAChB,gCAAgC;IAChC,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,oBAAoB;AACxB;AACA;IACI,gBAAgB;AACpB;CACC;IACG,YAAY;IACZ,YAAY;IACZ,gBAAgB;AACpB;AACA;MACM,WAAW;MACX,yBAAyB;MACzB,gBAAgB;MAChB,2BAA2B;MAC3B,8DAAsE;MACtE,uCAAuC;MACvC,iCAAiC;AACvC;AACA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,2BAA2B;IAC3B,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,6BAA6B;IAC7B,0BAA0B;AAC9B;AACA;IACI,wBAAwB;IACxB,iBAAiB;IACjB,kBAAkB;IAClB,gCAAgC;IAChC,6BAA6B;IAC7B,iBAAiB;IACjB,kBAAkB;AACtB;;;AAGA;IACI,gCAAgC;IAChC,6BAA6B;AACjC;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;AACA,4DAA4D;;AAE5D;IACI,YAAY;AAChB;AACA;IACI,YAAY;IACZ,mBAAmB;IACnB,0BAA0B;IAC1B,gBAAgB;IAChB,mBAAmB;IACnB,8BAA8B;IAC9B,wCAAwC;IACxC,gBAAgB;IAChB,6BAA6B;IAC7B,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,wBAAwB;IACxB,iDAAiD;IACjD,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,yBAAyB;AAC7B;AACA;IACI,uBAAuB;AAC3B;;;;;AAKA,wCAAwC,qBAAqB,EAAE;;AAE/D,2DAA2D;;AAE3D;IACI,gBAAgB;AACpB;AACA,iCAAiC,qBAAqB,EAAE;;AAExD;IACI,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,wCAAwC;IACxC,oBAAoB;IACpB,yBAAyB;IACzB,eAAe;IACf,UAAU;IACV,gBAAgB;AACpB;AACA;IACI,yBAAyB;IACzB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,UAAU;IACV,UAAU;AACd;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,qBAAqB;IACrB,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;AACpB;;;;AAIA;IACI;QACI,WAAW;QACX,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,yBAAyB;QACzB,8BAA8B;QAC9B,sBAAsB;QACtB,gBAAgB;QAChB,iBAAiB;QACjB,yBAAyB;QACzB,yBAAyB;IAC7B;AACJ;;;;AAIA;IACI,kBAAkB;IAClB,SAAS;IACT,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,oDAAoD;IACpD,gBAAgB;IAChB,YAAY;IACZ,yBAAyB;IACzB,aAAa;IACb,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,0BAA0B;IAC1B,eAAe;IACf,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,YAAY;AAChB;;IAEI;QACI,yBAAyB;QACzB,8BAA8B;QAC9B,sBAAsB;QACtB,gBAAgB;QAChB,YAAY;QACZ,yBAAyB;QACzB,yBAAyB;IAC7B;;;;;;;;;;;;;;;;;;;;;AAqBJ;;;;;GAKG;;;AAGH;IACI;QACI,YAAY;IAChB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,YAAY;QACZ,YAAY;;IAEhB;QACI,aAAa;IACjB;IACA;QACI,sBAAsB;QACtB,iBAAiB;KACpB;IACD;QACI,gBAAgB;QAChB,WAAW;QACX,iBAAiB;IACrB;IACA;QACI,mCAAmC;QACnC,0BAA0B;QAC1B,uBAAuB;QACvB,mBAAmB;QACnB,iBAAiB;IACrB;IACA;QACI,yCAAyC;QACzC,SAAS;IACb;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,oBAAoB;IACxB;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,oCAAoC;QACpC,YAAY;QACZ,kBAAkB;QAClB,WAAW;QACX,MAAM;QACN,YAAY;QACZ,UAAU;IACd;IACA;QACI,WAAW;QACX,YAAY;QACZ,gBAAgB;QAChB,yBAAyB;IAC7B;IACA;QACI,uCAAuC;QACvC,SAAS;IACb;IACA;;OAEG;IACH;QACI,gBAAgB;IACpB;IACA;QACI,iBAAiB;QACjB,eAAe;IACnB;IACA;QACI,sBAAsB;QACtB,6BAA6B;QAC7B,eAAe;IACnB;IACA;QACI,eAAe;IACnB;;;AAGJ;;AAEA;;IAEI,qBAAqB,WAAW,GAAG,UAAU,EAAE;IAC/C,sBAAsB,WAAW,GAAG,UAAU,EAAE;;IAEhD,wBAAwB,UAAU,EAAE;;;AAGxC;AACA;;IAEI,oBAAoB,oBAAoB,EAAE;IAC1C,YAAY,gBAAgB,GAAG;IAC/B,2CAA2C,WAAW,GAAG,WAAW,EAAE,YAAY,GAAG,aAAa,EAAE;IACpG,eAAe,qBAAqB,EAAE;IACtC,wBAAwB,aAAa,EAAE;IACvC,uBAAuB,kBAAkB,EAAE,eAAe,GAAG,WAAW,EAAE;IAC1E,iDAAiD,oBAAoB,EAAE;IACvE,0DAA0D,YAAY,GAAG;IACzE,yCAAyC,yBAAyB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE;IAC9G,aAAa,kBAAkB,EAAE,SAAS,EAAE,OAAO,EAAE;IACrD,eAAe,eAAe,GAAG,iBAAiB,EAAE;IACpD,oDAAoD,qBAAqB,EAAE;IAC3E,iJAAiJ,oBAAoB,GAAG;IACxK,8EAA8E,UAAU,CAAC;IACzF,yHAAyH,kCAAkC,EAAE,mBAAmB,EAAE,aAAa,CAAC;IAChM,+MAA+M,WAAW,EAAE;IAC5N,6DAA6D,mBAAmB,EAAE;IAClF,4CAA4C,gBAAgB,EAAE;;;IAG9D;QACI,gBAAgB;IACpB;IACA;QACI,iBAAiB;QACjB,eAAe;IACnB;IACA;QACI,sBAAsB;QACtB,6BAA6B;QAC7B,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,4BAA4B;QAC5B,oBAAoB;IACxB;IACA;QACI,YAAY;IAChB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,aAAa;IACjB;IACA;QACI,uBAAkB;QAAlB,kBAAkB;QAClB,2BAA2B;QAC3B,8BAA8B;QAC9B,kBAAkB;QAClB,eAAe;IACnB;IACA;QACI,4BAA4B;QAC5B,6BAA6B;IACjC;IACA;QACI,gBAAgB;IACpB;IACA;QACI,sBAAsB;QACtB,oBAAoB;IACxB;;IAEA;QACI,gBAAgB;IACpB;IACA;QACI,eAAe;QACf,kBAAkB;IACtB;IACA;QACI,cAAc;IAClB;IACA;QACI,cAAc;IAClB;IACA;QACI,gBAAgB;QAChB,sBAAsB;QACtB,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,eAAe;QACf,YAAY;IAChB;IACA;QACI,eAAe;QACf,SAAS;QACT,UAAU;QACV,qBAAqB;QACrB,sBAAsB;QACtB,6BAA6B;IACjC;IACA;;;sBAGkB;;IAElB;QACI,uCAAuC;QACvC,4BAA4B;IAChC;IACA;QACI,gBAAgB;IACpB;IACA;QACI,YAAY;QACZ,YAAY;QACZ,gBAAgB;IACpB;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,uBAAkB;QAAlB,kBAAkB;QAClB,WAAW;IACf;IACA;QACI,cAAc;QACd,eAAe;QACf,MAAM;QACN,SAAS;QACT,OAAO;QACP,QAAQ;QACR,UAAU;QACV,YAAY;IAChB;IACA;QACI,gBAAgB;QAChB,oBAAoB;IACxB;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,WAAW;QACX,mBAAmB;IACvB;IACA;QACI,aAAa;QACb,gBAAgB;IACpB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,aAAa;IACjB;IACA;QACI,0CAA0C;QAC1C,eAAe;QACf,YAAY;QACZ,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,kBAAkB;IACtB;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,WAAW;QACX,iBAAiB;IACrB;IACA;QACI,kBAAkB;QAClB,0BAA0B;IAC9B;IACA;QACI,WAAW;QACX,aAAa;QACb,gBAAgB;IACpB;IACA;QACI,oCAAoC;QACpC,gBAAgB;IACpB;;;IAGA;QACI,YAAY;QACZ,gBAAgB;QAChB,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,oCAAoC;QACpC,gBAAgB;QAChB,4GAA4G;QAC5G,kBAAkB;IACtB;IACA;QACI,uBAAuB;QACvB,mBAAmB;QACnB,mBAAmB;QACnB,yBAAyB;QACzB,eAAe;QACf,kCAAkC;QAClC,wBAAwB;QACxB,WAAW;QACX,sCAAsC;IAC1C;IACA;QACI,eAAe;QACf,mBAAmB;IACvB;IACA;QACI,cAAc;QACd,eAAe;QACf,UAAU;QACV,SAAS;IACb;IACA;QACI,WAAW;IACf;IACA;QACI,kBAAkB;QAClB,0BAA0B;IAC9B;IACA;QACI,iBAAiB;IACrB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,mBAAmB;QACnB,WAAW;QACX,QAAQ;IACZ;IACA;QACI,6BAA6B;QAC7B,8BAA8B;IAClC;IACA;QACI,mBAAmB;QACnB,mBAAmB;IACvB;IACA;QACI,gBAAgB;QAChB,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;IACA;QACI,aAAa;QACb,mBAAmB;IACvB;IACA;QACI,8BAA8B;IAClC;IACA;QACI,8BAA8B;QAC9B,qBAAqB;QACrB,WAAW;QACX,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,YAAY;QACZ,kBAAkB;IACtB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,sBAAsB;QACtB,uCAAuC;QACvC,yBAAyB;IAC7B,4BAA4B;IAC5B;IACA;QACI,iBAAiB;QACjB,WAAW;IACf;IACA;QACI,gBAAgB;QAChB,mBAAmB;IACvB;IACA;QACI,WAAW;IACf;IACA;QACI,sBAAsB;QACtB,gBAAgB;IACpB;IACA;QACI,WAAW;IACf;IACA;QACI,cAAc;IAClB;;IAEA;QACI,YAAY;IAChB;IACA;QACI,aAAa;IACjB;IACA;QACI,aAAa;IACjB;IACA;QACI,qBAAqB;IACzB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,kBAAkB;IACtB;;IAEA;QACI,QAAQ;IACZ;IACA;QACI,mBAAmB;IACvB;IACA;QACI,4BAA4B;IAChC;IACA;QACI,SAAS;IACb;;IAEA;QACI,UAAU;QACV,WAAW;IACf;IACA;QACI,UAAU;QACV,YAAY;IAChB;IACA;QACI,kBAAkB;QAClB,aAAa;QACb,WAAW;QACX,YAAY;QACZ,4BAA4B;IAChC;;;AAGJ;AACA;;;IAGI;QACI,wBAAwB;IAC5B;IACA;QACI,eAAe;QACf,SAAS;QACT,UAAU;QACV,qBAAqB;QACrB,sBAAsB;QACtB,6BAA6B;IACjC;IACA,yBAAyB,kBAAkB,EAAE;IAC7C,sBAAsB,2BAA2B,CAAC;IAClD;QACI,kBAAkB;QAClB,aAAa;QACb,WAAW;QACX,YAAY;QACZ,4BAA4B;IAChC;;IAEA;QACI,eAAe;QACf,gCAAgC;IACpC;IACA;QACI,WAAW;QACX,6BAA6B;QAC7B,gBAAgB;IACpB;IACA,wBAAwB,eAAe,CAAC;IACxC;QACI;iCACyB;QACzB,0BAA0B;QAC1B,gBAAgB;QAChB,8BAA8B;QAC9B,wBAAwB;IAC5B;IACA,0BAA0B,gCAAgC,EAAE,+BAA+B,EAAE;;IAE7F,2BAA2B,iBAAiB,EAAE;IAC9C,0BAA0B,aAAa,EAAE;IACzC,gCAAgC,iCAAiC,EAAE;IACnE,0CAA0C,UAAU,EAAE;IACtD,sCAAsC,cAAc,EAAE;IACtD;QACI,oBAAoB;IACxB;IACA,qCAAqC,uBAAuB,EAAE;IAC9D,yDAAyD,cAAc,EAAE,wBAAwB,EAAE;IACnG,mDAAmD,2BAA2B,EAAE;IAChF,+EAA+E,eAAe,EAAE;IAChG,uDAAuD,oBAAoB,EAAE;;IAE7E;QACI,eAAe;QACf,eAAe;QACf,cAAc;IAClB;IACA;QACI,qCAAqC;IACzC;IACA;QACI,aAAa;QACb,WAAW;QACX,mBAAmB;IACvB;IACA;QACI,eAAe;QACf,uBAAuB;IAC3B;IACA;;;OAGG;IACH;QACI,WAAW;IACf;IACA;OACG,qBAAqB;IACxB;IACA;QACI,aAAa;QACb,kBAAkB;IACtB;IACA;QACI,cAAc;IAClB;IACA;QACI,mBAAmB;QACnB;sBACc;QACd,mBAAmB;QACnB,WAAW;QACX,8BAA8B;IAClC;IACA;QACI,cAAc;QACd,iCAAiC;QACjC,0BAA0B;QAC1B,gBAAgB;QAChB,cAAc;IAClB;;;AAGJ;AACA;;IAEI;QACI,kBAAkB;QAClB,gBAAgB;IACpB;IACA;QACI,sBAAsB;QACtB,qBAAqB;IACzB;;IAEA;OACG,eAAe;QACd,0BAA0B;QAC1B,SAAS;QACT,eAAe;QACf,kBAAkB;IACtB;IACA;QACI,WAAW;QACX,MAAM;QACN,OAAO;QACP,kBAAkB;QAClB,oCAAoC;QACpC,aAAa;QACb,eAAe;IACnB;IACA;QACI,WAAW;QACX,kBAAkB;QAClB,uBAAuB;QACvB,iBAAiB;IACrB;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,eAAe;QACf,gBAAgB;QAChB,0BAA0B;IAC9B;IACA;QACI,cAAc;QACd,iCAAiC;QACjC,0BAA0B;QAC1B,gBAAgB;QAChB,cAAc;IAClB;IACA;QACI,cAAc;QACd,iCAAiC;QACjC,eAAe;QACf,gBAAgB;QAChB,cAAc;IAClB;IACA;QACI,kBAAkB;QAClB,aAAa;QACb,WAAW;QACX,YAAY;QACZ,4BAA4B;IAChC;IACA;QACI,eAAe;QACf,SAAS;QACT,UAAU;QACV,yBAAyB;QACzB,sBAAsB;IAC1B;IACA;QACI,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,sBAAsB;IAC1B;IACA;QACI,WAAW;QACX,6BAA6B;QAC7B,gBAAgB;IACpB;IACA;QACI,6BAA6B;QAC7B,sBAAsB;QACtB,aAAa;IACjB;;IAEA;QACI,kBAAkB;QAClB,6BAA6B;QAC7B,YAAY;QACZ,eAAe;QACf,iBAAiB;QACjB,mBAAmB;QACnB,wDAAwD;QACxD,8BAA8B;QAC9B,6BAA6B;QAC7B,aAAa;IACjB;IACA;OACG,kBAAkB;OAClB,aAAa;IAChB;IACA;QACI,4BAA4B;IAChC;IACA;QACI,yCAAyC;QACzC,qBAAqB;QACrB,WAAW;QACX,kBAAkB;QAClB,0BAA0B;IAC9B;IACA;QACI,yBAAyB;IAC7B;IACA;QACI,mBAAmB;QACnB;wBACgB;QAChB,mBAAmB;QACnB,WAAW;IACf;IACA;QACI,aAAa;QACb,kBAAkB;IACtB;IACA;QACI,wBAAwB;QACxB,aAAa;QACb,WAAW;QACX,sBAAsB;IAC1B;IACA,2CAA2C,UAAU,GAAG;;IAExD,+BAA+B,eAAe,EAAE,wBAAwB,EAAE,WAAW,EAAE,gBAAgB,GAAG;;IAE1G;QACI,WAAW;QACX,sBAAsB;QACtB,yBAAyB;QACzB,gBAAgB;QAChB,uBAAuB;QACvB,kBAAkB;QAClB,aAAa;IACjB;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,cAAc;QACd,oBAAoB;QACpB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,mBAAmB;QACnB,mCAAmC;QACnC,iCAAiC;IACrC;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,wBAAwB;QACxB,8BAA8B;QAC9B,wBAAwB;QACxB,sCAAsC,EAAE;IAC5C,yDAAyD,kBAAkB,CAAC;IAC5E,yDAAyD,oBAAoB,GAAG,WAAW,GAAG,UAAU,CAAC;;IAEzG,uCAAuC,aAAa,EAAE,8BAA8B,EAAE,mBAAmB,EAAE;;IAE3G,2BAA2B,mCAAmC,EAAE;;IAEhE,mCAAmC,4BAA4B,GAAG;;IAElE,sCAAsC,cAAc,EAAE;;IAEtD,uBAAuB,wBAAwB,EAAE;;IAEjD;QACI,0BAA0B;QAC1B,2BAA2B;QAC3B,eAAe;QACf,6BAA6B;IACjC;IACA;QACI,iBAAiB;QACjB,8BAA8B;IAClC;;IAEA;QACI,eAAe;QACf,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,yBAAyB;QACzB,oBAAoB;QACpB,sBAAsB;IAC1B;;IAEA;;;OAGG;;IAEH;QACI,2BAA2B;QAC3B,qBAAqB;QACrB,wBAAwB;QACxB,uBAAuB;QACvB,WAAW;IACf;IACA,yCAAyC,kBAAkB,EAAE;;;AAGjE;;AAEA;;IAEI;QACI,WAAW;QACX,WAAW;QACX,kBAAkB;QAClB,kBAAkB;IACtB;IACA;QACI,WAAW;QACX,YAAY;QACZ,6BAA6B;QAC7B,mBAAmB;IACvB;IACA,uBAAuB,aAAa,EAAE;IACtC,eAAe,gBAAgB,EAAE;IACjC,iBAAiB,eAAe,EAAE;IAClC;QACI,WAAW;QACX,uBAAuB;QACvB,aAAa;IACjB;AACJ","sourcesContent":["\nbutton.burgermenu {\n    display: none;\n}\nbutton.menu-btn.back {\n    display: none;\n}\n.sidebarWraper {\n    height: 100% !important;\n}\n\n/* LOGIN-DESIGN START */\n.login-box .topParts {\n    padding: 3px 0 0 0;\n}\n.login-box h2 {\n    color: #302B3A;\n    font-size: 24px;\n    font-weight: 600;\n    margin: 10px 0;\n    padding: 0;\n}\n\n.login-box h4 {\n    color: #666666;\n    font-size: 15px;\n    font-weight: 500;\n    margin: 10px 0 5px;\n    padding: 0;\n}\n.login_container .loginForm .form-control {\n    border-radius: 10px;\n    min-height: 45px;\n}\n.login_bg .alignBx {\n    display: flex;\n    align-items: center;\n    height: 100%;\n    justify-content: center;\n}\n.loginHeader {\n    padding: 15px;\n    position: fixed;\n    left: 0;\n    top: 0;\n    z-index: 10;\n    background: #FFF;\n    border-bottom: 1px solid #DFDFDF;\n    height: auto;\n    min-height: 79px;\n}\n.loginHeader .container-fluid{\n    padding-left: 7.5px;\n    padding-right: 7.5px;\n}\n.login_logo .logo_Img  {\n    max-width: 135px;\n}\n .login_bg{\n    padding: 0px;\n    height: 100%;\n    margin-top: 70px;\n}\n.bgOuter .leftBg {\n      float: left;\n      width: calc(100% - 587px);\n      padding: 15px 5%;\n      height: calc(100vh - 70px );\n      background: url(../../assets/images/MagicPatterndesign.png) !important;\n      background-repeat: no-repeat !important;\n      background-size: cover !important;\n}\n.bgOuter .rightBg {\n    width: 587px;\n    float: right;\n    max-width: 100%;\n    background: #F8F8F8;\n    height: calc(100vh - 70px );\n    padding: 15px 5%;\n}\n.sliderWrapper .sliderImg .sliderImg {\n    max-width: 100%;\n    max-height: 400px;\n    width: auto;\n    object-fit: cover;\n    margin: 0 auto;\n}\n.sliderWrapper .sliderCont .slide_title {\n    color: #302B38;\n    font-size: 16px;\n    font-weight: 600;\n    margin: 20px 0 10px;\n}\n.sliderWrapper .sliderCont .slide_des {\n    color: #666666;\n    font-size: 15px;\n    font-weight: 500;\n    line-height: 20px;\n    margin: 0 0 5px;\n}\n.login-box .frgPasrd {\n    color: #666666;\n    font-size: 15px;\n    font-weight: 500;\n}\n.login-box input.form-control {\n    height: 45px;\n    border: 1px solid #DFDFDF;\n    border-radius: 10px;\n    border-bottom-right-radius: 0;\n    border-top-right-radius: 0;\n}\nbutton.btn.eye-bttn {\n    border:1px solid #DFDFDF;\n    background: white;\n    border-radius: 0px;\n    border-bottom-right-radius: 12px;\n    border-top-right-radius: 12px;\n    border-left: none;\n    margin-left: -10px;\n}\n\n\ninput.form-control.inputs-radus {\n    border-bottom-right-radius: 12px;\n    border-top-right-radius: 12px;\n}\n.loginHeader .login_link a {\n    color: #302B3A;\n    font-size: 15px;\n    font-weight: 500;\n}\n/* .login-box .Auth_button__wLxLD{ margin: 0 !important; } */\n\n.rightBg .sliderWrapper {\n    padding: 5px;\n}\n.login-box button.btn.btn-primary {\n    height: 50px;\n    background: #3A68D8;\n    font-size: 15px !important;\n    font-weight: 700;\n    border-radius: 10px;\n    margin-bottom: 0rem !important;\n    margin-top: calc(2rem - 10px) !important;\n    line-height: 1.5;\n    border: 1px solid transparent;\n    cursor: pointer !important;\n}\n\n.login-box ul.dropdown-menu.show {\n    right: 0 !important;\n    left: inherit !important;\n    transform: translate3d(0px, 30px, 0px) !important;\n    width: auto;\n    min-width: 120px;\n    padding: 3px 0;\n    border: 1px solid #DFDFDF;\n}\n.login-box .topParts .dropdown-item:hover, .login-box .topParts .dropdown-item:focus{\n    background: transparent;\n}\n\n\n\n\n.login-box .paddingSp .form-group.mb-3{ margin: 1.5rem 0 1rem; }\n\n/* .login-box .Auth_button__JNDtr{margin: 0 !important; } */\n\n.bgOuter .login-box .form_Header{\n    margin-bottom: 0;\n}\n.bgOuter .login-box .login-logo{ margin-bottom: 0.9rem; }\n\n.bgOuter .login-box .logo_Img{     \n    max-width: 135px;\n}\n.login-box .topParts .dropdown-toggle{\n    white-space: nowrap;\n    background-color: transparent !important;\n    border: 0 !important;\n    color: #666666 !important;\n    font-size: 15px;\n    padding: 0;\n    font-weight: 500;\n}\n.login-box .topParts .dropdown-item{\n    color: #666666 !important;\n    font-size: 15px;\n    font-weight: 500;\n}\n.login-box .container.form.paddingSp{\n    max-width: 100%; \n    width:100%;\n    padding: 0;\n}\n\n.login_bg .login-box{\n    max-width: 100%;\n    width: 650px;\n    display: inline-table;\n    text-align: left;\n    border: 1px solid #DFDFDF;\n    border-radius: 20px;\n    padding: 2rem;\n    background: #FFF;\n}\n\n\n\n@media (max-width: 640px) {\n    iframe.frame-view {\n        width: 100%;\n        height: 280px;\n    }\n}\n\n@media (max-width: 580px) {\n    li.list-group-item.bordes-div {\n        border: 1px solid #DFDFDF;\n        border-radius: 10px !important;\n        background-color: #FFF;\n        overflow: hidden;\n        min-height: 100px;\n        margin: 10px 0px 19px 0px;\n        padding: 2px 0px 0px 20px;\n    }\n}\n\n  \n\nimg.menu_icon.search.res-icon {\n    position: absolute;\n    left: 8px;\n    top: 13px !important;\n    width: 15px;\n}\n\n.searchere.mb-0.serach-div.resours-div {\n    align-items: center;\n    border-radius: 10px;\n    border: 1px solid var(--light-gray-outline, #DFDFDF);\n    background: #FFF;\n    height: 40px;\n    justify-content: flex-end;\n    display: flex;\n    margin-top: 7px;\n    float: right;\n    position: relative;\n    width: 321px;\n    max-width: 100%;\n    margin-right: 21px;\n}\np.form-name.res-tittle.my-1 {\n    color: #3A68D8;\n    font-weight: 600;\n    text-decoration: underline;\n    font-size: 15px;\n    cursor: pointer;\n}\n.search.serach-width-div.res-div.col-md-4 {\n    position: relative;\n    width: 380px;\n    max-width: 100%;\n    float: right;\n}\n\n    li.list-group-item.bordes-div {\n        border: 1px solid #DFDFDF;\n        border-radius: 10px !important;\n        background-color: #FFF;\n        overflow: hidden;\n        height: 61px;\n        margin: 10px 0px 19px 0px;\n        padding: 2px 0px 0px 20px;\n    }\n       \n      \n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* \n@media screen and (max-height: 2100px){\n    .d-flex.detail-user, .can-lists {\n        min-height: 71vh !important;\n    }\n} */\n\n\n@media screen and (max-width: 1040px) {\n    .sidebarWraper {\n        height: 100%;\n    }\n    nav.sidebar {\n        padding: 0px 10px;\n    }\n    .sidebar {\n        height: 100%;\n        width: 214px}\n\n    span.menu-title {\n        display: none;\n    }\n    nav.sidebar{\n        width: 85px !important;\n        padding: 0px 10px;\n     }\n    nav.sidebar.active {\n        /* width: 35%; */\n        width: 85px;\n        padding: 0px 10px;\n    }\n    .mainHeader {\n        width: calc(100% - 85px) !important;\n        position: fixed !important;\n        z-index: 999 !important;\n        right: 0 !important;\n        top: 0 !important;\n    }\n    .sidebar_open.fixed-side {\n        padding: 111px 20px 20px 111px !important;\n        margin: 0;\n    }\n\n    .logoContainer {\n        width: 62px;\n        overflow-x: hidden;\n        pointer-events: none;\n    }\n    .sidebar ul.nav .accordion-button, .sidebar ul.nav a.nav-link {\n        justify-content: center;\n    }\n    .sidebar a.nav-link.active::before {\n        border-left: 3px solid var(--color1);\n        content: ' ';\n        position: absolute;\n        left: -10px;\n        top: 0;\n        height: 100%;\n        z-index: 1;\n    }\n    .logoContainer img {\n        width: 70px;\n        height: 45px;\n        object-fit: none;\n        object-position: 10px 0px;\n    }\n    .ht-box .content-sc, .ht-box .sidebar_open {\n        padding: 60px 20px 20px 20px !important;\n        margin: 0;\n    }\n    /* .sidebar.active a.nav-link.active::before {\n        left: -25px;\n    } */\n    .Auth_form__IOjvb {\n        box-shadow: none;\n    }\n    .Auth_form__IOjvb h3 {\n        font-weight: bold;\n        font-size: 30px;\n    }\n    .Auth_form__IOjvb input.form-control {\n        border: 1px solid #ccc;\n        padding: 10px 16px !important;\n        margin-top: 5px;\n    }\n    .Auth_form__IOjvb input.form-control::placeholder {\n        font-size: 14px;\n    }\n        \n\n}\n\n@media(max-width: 991px){\n\n    .login_bg  .leftBg { float: left;  width: 60%; } \n    .login_bg  .rightBg { float: left;  width: 40%; }\n\n    .sideCont .sidebarFixs{ width: 22%; }\n    \n\n}\n@media screen and (max-width: 767px) {\n    \n    .candPrv .logo-sec{ margin: 0 !important; }\n    .login_bg { margin-top: 70px;  }\n    .login_bg  .leftBg,  .login_bg  .rightBg { float: left;  width: 100%; height: auto;  padding: 2rem; } \n    .thanku-cards{ width: 93% !important; }\n    .thanku-cards .card-1 { padding: 35px; }\n    .sideCont .sidebarFixs{position: relative; max-width: 100%;  width: 100%; }\n    .e-toolbar-items.e-tbar-pos .e-toolbar-center {  margin: 0 !important; }\n    .e-toolbar .e-toolbar-items.e-tbar-pos .e-toolbar-right { float: right;  }\n    .e-control.e-toolbar.e-lib.e-keyboard {  border: 1px solid #e8e8e8; border-bottom: 0; width: 100% !important; }\n    .cardPost {  position: relative; bottom: 0; left: 0; }\n    .welcome-text {font-size: 28px;  line-height: 28px; }\n    .padd-review-page .rev-padd-tap button.confirm-btn{ margin: 0 10px 10px 0; }\n    .rightCont .collap-head .alignHead_review .task-count, .rightCont .action-itms.full-drp.flex-column .d-flex.justify-content-between .task-count{ justify-content: end;  }\n    .padd-review-inner .alignHead_review .hd-can-review.create-form-wrp.newPad {  width:100%;}\n    .rightCont .collap-head .alignHead_review, .rightCont .action-itms.full-drp.flex-column .d-flex.justify-content-between{ /*flex-direction: column-reverse;*/ flex-direction: row; padding: 10px;}\n    .rightCont .collap-head .alignHead_review .hd-can-review.create-form-wrp.newPad.alig_cent, .rightCont .action-itms.full-drp.flex-column .d-flex.justify-content-between .hd-can-review.neSp.create-form-wrp {  width: 100%; }\n    .rightCont .padd-review-inner.collap-head .alignHead_review{ flex-direction: row; }\n    .rightCont .action-itms button.select-btn { padding-right: 0; }\n\n \n    .Auth_form__IOjvb {\n        box-shadow: none;\n    }\n    .Auth_form__IOjvb h3 {\n        font-weight: bold;\n        font-size: 30px;\n    }\n    .Auth_form__IOjvb input.form-control {\n        border: 1px solid #ccc;\n        padding: 10px 16px !important;\n        margin-top: 5px;\n    }\n    .Auth_form__IOjvb input.form-control::placeholder {\n        font-size: 14px;\n    }\n    button.btn.btn-primary.btn-block.w-100.mt-4 {\n        font-size: 20px;\n    }\n    .mainWrap header.mainHeader {\n        width: 100% !important;\n    }\n    .mainWrap .content-sc, .mainWrap .sidebar_open {\n        padding: 60px 20px 5px 20px ;\n        margin: 0 !important;\n    }\n    header {\n        height: 60px;\n    }\n    .ht-box {\n        margin-top: 50px;\n    }\n    .col-md-8.col-lg-9.candPads {\n        display: none;\n    }\n    .men-btn.d-flex.align-items-center {\n        width: fit-content;\n        justify-content: flex-start;\n        flex-direction: row !important;\n        overflow-x: scroll;\n        margin-top: 8px;\n    }\n    button.status-btn {\n        margin-right: 5px !important;\n        min-width: inherit !important;\n    }\n    .action-itms.ac-spaceBt.d-flex.align-items-center.justifycontent-between.px-3 {\n        margin-top: 12px;\n    }\n    .searchere img {\n        width: 18px !important;\n        top: 20px !important;\n    }\n\n    .tables.docTable {\n        overflow: scroll;\n    }\n    .searchere input::placeholder {\n        font-size: 17px;\n        padding-left: 10px;\n    }\n    .userarea {\n        display: block;\n    }\n    button.burgermenu {\n        display: block;\n    }\n    button.burgermenu {\n        background: #fff;\n        border: 1px solid #ccc;\n        font-size: 14px;\n        padding: 6px 10px;\n    }\n    nav.sidebar {\n        position: fixed;\n        left: -290px;\n    }\n    nav.sidebar.active {\n        position: fixed;\n        left: 0px;\n        top: -60px;\n        width: 15% !important;\n        border: 1px solid #ccc;\n        /* height: auto !important; */\n    }\n    /*nav.sidebar.active {\n        position: fixed;\n        left: -20px;\n        top: -50px; }*/\n   \n    .collapseView .content-sc, .collapseView .sidebar_open {\n        padding: 50px 20px 20px 58px !important;\n        margin-left: 10px !important;\n    }\n    .searchere.mb-0 {\n        margin-top: 15px;\n    }\n    .logoContainer img {\n        width: 110px;\n        height: 25px;\n        margin-top: 50px;\n    }\n    .collapseView header.mainHeader {\n        width: 100% !important;\n    }\n    .footer_collapse.mt-2 p {\n        width: fit-content;\n        color: #fff;\n    }\n    .col-md-8.col-lg-9.candPads.active {\n        display: block;\n        position: fixed;\n        top: 0;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        padding: 0;\n        z-index: 999;\n    }\n    .d-flex.detail-user {\n        min-height: 100%;\n        border-radius: 0px !;\n    }\n    .llbw {\n        flex-direction: column;\n    }\n    .llbw .candidate {\n        width: 100%;    \n        margin-bottom: 20px;\n    }\n    .detail-tabs ul.react-tabs__tab-list {\n        display: flex;\n        overflow-x: auto;\n    }\n    .detail-tabs .react-tabs__tab {\n        white-space: nowrap;\n    }\n    span.username {\n        display: none;\n    }\n    .llbw .avatar {\n        background-color: var(--color1) !important;\n        min-width: 60px;\n        height: 60px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        margin-bottom: 8px;\n    }\n    .llbw .avatar p{\n        color: #fff !important;\n    }\n    .llbw .ca-details {\n        width: 100%;\n        margin-left: 10px;\n    }\n    .llbw  .ca-details h3 {\n        margin-bottom: 0px;\n        font-size: 15px !important;\n    }\n    .filterAlign {\n        width: 100%;\n        padding: 10px;\n        margin-top: 10px;\n    }\n    .candPads {\n        padding: 5px 18px 3px 4px !important;\n        margin-left: 8px;\n    }\n\n\n    .form-select.drop-filter.customFilt.select-box {\n        height: 40px;\n        overflow-y: auto;\n        width: 100% !important;\n    }\n\n    .sidebar a.nav-link.active {\n        color: #FFF;\n        /* border-left: 3px solid #3A68D8; */\n        font-weight: 500;\n        background: linear-gradient(90deg, #3A68D8 0%, rgba(58, 104, 216, 0.00) 100%, rgba(58, 104, 216, 0.00) 100%);\n        margin-left: -10px;\n    }\n    .sidebar .nav a.nav-link {\n        /* padding: 0px 10px; */\n        /* display: flex; */\n        align-items: center;\n        /* min-height: inherit; */\n        cursor: pointer;\n        /* padding-left: 1px !important; */\n        /* position: relative; */\n        width: 100%;\n        padding:15px 10px 15px 10px !important;\n    }\n    .llbw .ca-details span {\n        font-size: 16px;\n        margin-bottom: 10px;;\n    }\n    button.menu-btn.back {\n        display: block;\n        position: fixed;\n        left: 20px;\n        top: 15px;\n    }\n    ul.actn-btns {\n        width: 100%;\n    }\n    .detail-tabs th.firstTab, .detail-tabs td.firstTab {\n        min-width: inherit;\n        padding-left: 0 !important;\n    }\n    .onb-actions a, .onb-actions select {\n        padding: 8px 12px;\n    }\n    .team-member select {\n        padding: 8px 12px;\n    }\n    .onb-actions {\n        flex-direction: row;\n        width: 100%;\n        gap: 5px;\n    }\n    .action-itms-forms.bxShw.px-2.py-4.mb-4 {\n        margin-bottom: 5px !important;\n        padding-bottom: 7px !important;\n    }\n    .f-itm {\n        flex-direction: row;\n        align-items: center;\n    }\n    button.Save {\n        margin-top: 10px;\n        width: 100%;\n        margin-bottom: 40px;\n    }\n\n    .sub-acc.blueborder.newBorder {\n        border-radius: 10px;\n    }\n    .wraper.listTmplt {\n        display: flex;\n        align-items: center;\n    }\n    .icon-dele {\n        margin-top: inherit !important;\n    }\n    .icon-dele {\n        margin-top: inherit !important;\n        background: #cccccc6e;\n        width: 35px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        height: 35px;\n        border-radius: 5px;\n    }\n    .sub-acc.padSpace {\n        margin-top: 10px;\n    }\n    .ReactModal__Content.ReactModal__Content--after-open {\n        width: 100% !important;\n        transform: translate(0%, 0%) !important;\n        max-width: 95% !important;\n    margin-left: 10px !important;\n    }\n    .sidebarFixs {\n        position: inherit;\n        width: 100%;\n    }\n    .col-lg-10.col-md-9.rightCont {\n        margin-top: 25px;\n        margin-bottom: 10px;\n    }\n    .e-toolbar-item button {\n        z-index: 99;\n    }\n    .candPads .alignTops {\n        flex-direction: column;\n        margin-top: 40px;\n    }\n    .candPads .alignTops .dropdown, .candPads .alignTops .dropdown button  {\n        width: 100%;\n    }\n    .f-btns .btn {\n        width: inherit;\n    }\n\n    .footer_collapse {\n        z-index: 999;\n    }\n    .component h6 {\n        display: none;\n    }\n    .sub-acc.h-100.padSpace {\n        padding: 15px;\n    }\n    .alignBox.fn-main ul .boxDiv {\n        width: calc(100% / 5);\n    }\n    .alignBox.fn-main ul li .component {\n        min-height: 50px;\n    }\n    img.create-icon {\n        margin-bottom: 0px;\n    }\n\n    .row.create-grd .col-lg-6 {\n        order: 3;\n    }\n    div#scrollDiv {\n        order: 2 !important;\n    }\n    ul.MuiList-root.MuiList-padding {\n        min-height: 400px !important;\n    }\n    .d-flex.detail-user {\n        border: 0;\n    }\n\n    .login-box .login-logo.text-left {\n        width: 50%;\n        float: left;\n    }\n    .login-box .topParts .col-sm-4.text-ends {\n        width: 50%;\n        float: right;\n    }\n    .switchs {\n        position: relative;\n        display: flex;\n        width: 45px;\n        height: 22px;\n        margin-left: -5px !important;\n    }\n\n\n}\n@media(max-width: 580px){\n\n\n    .text-padd {\n        padding: 10px !important;\n    }\n    nav.sidebar.active {\n        position: fixed;\n        left: 0px;\n        top: -60px;\n        width: 15% !important;\n        border: 1px solid #ccc;\n        /* height: auto !important; */\n    }\n    .thanku-cards .card-1 {  padding: 25px 15px; }\n    .thanku-sub-heading{  text-align: left !important;}\n    .switchs {\n        position: relative;\n        display: flex;\n        width: 45px;\n        height: 22px;\n        margin-left: -5px !important;\n    }\n\n    .task-itms {\n        font-size: 15px;\n        /* min-width: 100% !important; */\n    }\n    .line-border {\n        width: 100%;\n        border-top: 2px solid #F6F6F6;\n        margin: 60px 0 0;\n    }\n    .login_bg .login-box {  padding: 1.5rem;}\n    .otp-enter input[type=tel] {\n        /*width: 46px !important;\n        height: 62px !important;*/  \n        max-width: 35px !important;\n        max-height: 42px;\n        border-radius: 10px !important;\n        margin: 0 5px !important;\n    }\n    .row.px-4.topSpce_view {  padding-right: 0.5rem !important; padding-left: 0.5rem !important; }\n\n    ul.status-ind.viewList a { padding: 5px 10px; }\n    .rightCont .action-itms { padding: 10px; }\n    .padd-review-page .padd-main {  padding: 0 15px 0px 0px!important; }\n    .rightCont .width-flex.w-100.collap-head{ padding: 0; }\n    .rightCont .contents-sub.padd-main {  padding: 5px 0; }\n    .contents-sub.padd-main .my-0.rev-padd-tap {\n        padding: 0 15px 10px;\n    }\n    .contents-sub.fulWid .btnAlg_same {  margin: 0 10px 10px 0px; }\n    .contents-sub.fulWid .btnAlg_same button.confirm-btn{    margin-left: 0; margin-top: 0 !important; }\n    .action-itms .contents-sub.fulWid .w-100 >.my-2 {  margin-top: 0rem !important; }\n    .padd-review-inner .alignHead_review .hd-can-review.create-form-wrp.newPad {   padding-left: 0; }\n    .rightCont .collap-head .alignHead_review .task-count{ margin: 0 !important; }\n\n    .e-toolbar .e-toolbar-item {\n        height: inherit;\n        min-width: 100%;\n        padding: 3.5px;\n    }\n    .padd-review-page .padd-main {\n        margin: 10px 10px 10px 10px!important;\n    }\n    .video-thumb {\n        height: 260px;\n        width: 100%;\n        border-radius: 15px;\n    }\n    .img-divs {\n        min-width: 100%;\n        margin: 0px 0px 0px 6px;\n    }\n    /* .e-spinner-pane.e-spin-hide {\n        display: inline-flex;\n        height: 100vh;\n    } */\n    .e-hscroll .e-hscroll-content {\n        width: 100%;\n    }\n    .thanku-cards {\n       width: 95% !important;\n    }\n    .card-1 {\n        padding: 40px;\n        text-align: center;\n    }\n    .filter-main-div {\n        display: block;\n    }\n    .main-filter {\n        /* display: flex; */\n        /* margin: 0px 15px 0px 0px; \n        height: 65px;*/\n        align-items: center;\n        width: 100%;\n        margin-bottom: 10px !important;\n    }\n    .welcome-text {\n        color: #302b3a;\n        color: var(--Avenu-Black,#302b3a);\n        font-size: 30px !important;\n        font-weight: 700;\n        margin: 20px 0;\n    }\n    \n    \n}\n@media(max-width: 480px){\n\n    .detail-tabs .table tbody.table-text-body td {\n        text-wrap: balance;\n        min-width: 160px;\n    }\n    textarea#floatingTextarea {\n        height: 20px!important;\n        width: 100%!important;\n    }\n\n    .logoCent.logo-sec{\n       /* left: 45px;*/\n        position: fixed !important;\n        top: 15px;\n        font-size: 18px;\n        text-align: center;\n    }\n    .preview-bck-icon {\n        width: 25px;\n        top: 0;\n        left: 0;\n        position: absolute;\n        margin: 20px 0px 0px 15px !important;\n        z-index: 9999;\n        cursor: pointer;\n    }\n    .sideScroll {\n        width: 100%;\n        overflow-y: scroll;\n        height: auto !important;\n        max-height: 100vh;\n    }\n    .text-padd {\n        padding: 10px !important;\n    } \n    .rightCont .collap-head .alignHead_review .task-count .progress.custom.me-3 {\n        min-width: auto;\n        max-width: 120px;\n        margin-right: 0 !important;\n    }\n    .welcome-text {\n        color: #302b3a;\n        color: var(--Avenu-Black,#302b3a);\n        font-size: 30px !important;\n        font-weight: 700;\n        margin: 20px 0;\n    }\n    .welcome-text {\n        color: #302b3a;\n        color: var(--Avenu-Black,#302b3a);\n        font-size: 30px;\n        font-weight: 700;\n        margin: 20px 0;\n    }\n    .switchs {\n        position: relative;\n        display: flex;\n        width: 45px;\n        height: 22px;\n        margin-left: -5px !important;\n    }\n    nav.sidebar.active {\n        position: fixed;\n        left: 0px;\n        top: -60px;\n        /*width: 70% !important;*/\n        border: 1px solid #ccc;\n    }\n    nav.sidebar.active .logoContainer h1, nav.sidebar.active span.menu-title, nav.sidebar.active .accordion-button::after {\n        display:block; \n        font-size: 15px;\n    }\n    \n    .input-group-append.pass-div-width {\n        width: 100% !important;\n    }  \n    .line-border {\n        width: 100%;\n        border-top: 2px solid #F6F6F6;\n        margin: 60px 0 0;\n    }\n    .cardPost {\n        position: relative !important;\n        bottom: 0px !important;\n        /* left: 0; */\n    }\n\n    .cards.has-text-centered {\n        position: relative;\n        margin: -40px auto !important;\n        width: 800px;\n        max-width: 100%;\n        min-height: 299px;\n        border-radius: 10px;\n        border: 0.776px solid var(--light-gray-outline, #DFDFDF);\n        background: var(--White, #FFF);\n        transform: translate(0%, 30%);\n        padding: 15px;\n    }\n    li.list-group-item.same-line.rigt-alginn {\n       /* height: 230px;*/\n       height: 185px;\n    }\n    .first-ul {\n        margin-top: 80px  !important;\n    }\n    .onb-actions {\n        flex-direction: column-reverse !important;\n        width: 80% !important;\n        float: left;\n        position: absolute;\n        margin: 45px 0px 0px -70px;\n    }\n    .filter-main-div {\n        display: block !important;\n    }\n    .main-filter {\n        /* display: flex; */\n        /* margin: 0px 15px 0px 0px;\n         height: 65px; */\n        align-items: center;\n        width: 100%;\n    }\n    .card-1 {\n        padding: 40px;\n        text-align: center;\n    }\n    .alignHead_review, .rightCont .collap-head .alignHead_review {\n        justify-content: inherit;\n        display: flex;\n        width: 100%;\n        flex-direction: column;\n    }\n    .rightCont .collap-head .alignHead_review{ padding: 0;  }\n\n    .alignHead_review .task-itms { text-align: end; /* padding-right: 10px;*/ width: auto; min-width: 120px;  }\n\n    .alignHead_review .hd-can-review h4{ \n        width: 100%;\n        background-color: #fff;\n        white-space: break-spaces;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        padding-left: 31px;\n        margin: 5px 0;\n    }\n    .over-divz {\n        display: none !important;\n    }\n    .i9-text {\n        color: #D15D49;\n        font-family: Manrope;\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: normal;\n        margin: 7px 0px 0px 10px !important;\n        word-break: break-word !important;\n    }\n    .mobile-over-divz {\n        display: flex !important;\n    }\n    .action-itms .padd-review-inner{\n        padding: 10px !important;\n        flex-direction: row !important;\n        display: flex !important;\n        justify-content: flex-start !important; }\n    .alignHead_review .hd-can-review h4 > img.create-icon {  margin-left: -30px;}\n    .rightCont .collap-head .alignHead_review .task-count {  margin: 0 !important;  width: 100%;  padding: 0;}\n\n    .padd-review-inner .alignHead_review { display: flex; justify-content: space-between; flex-direction: row; }\n\n    .task-count.rev-marg-lft { margin: 0px 10px 0px 0px !important; }\n\n    .rightCont .hd-can-review.newPad { padding-left: 0px !important;  }\n\n    .padd-review-page button.confirm-btn{ margin-left: 0; }\n\n    button.confirm-btn {   margin: 0px 11px 0px 0px; }\n\n    .e-toolbar-item .e-tbar-btn.e-tbtn-txt.e-control#download {\n        margin-top: 0px !important;\n        min-height: 40px !important;\n        min-width: 100%;\n        margin-right: 10px !important;\n    }\n    .e-toolbar .e-toolbar-items .e-toolbar-left, .e-toolbar .e-toolbar-items .e-toolbar-center, .e-toolbar .e-toolbar-items .e-toolbar-right {\n        display: contents;\n        /* margin: 21px 0px 0px 0px; */\n    }\n\n    .e-toolbar .e-toolbar-item {\n        height: inherit;\n        min-width: 100%;\n        padding: 3.5px;\n    }\n\n    .inptFiles_up.aligDivs_rev p {\n        /* margin: 0; */\n        margin: 0px 0px 0px 110px;\n        /* max-width: 77%; */\n        word-break: break-word;\n    }\n\n    /* .e-spinner-pane.e-spin-hide {\n        display: inline-flex;\n        height: 100vh;\n    } */\n\n    .e-hscroll .e-hscroll-content {\n        /* display: inline-block; */\n        /* height: inherit; */\n        /* position: relative; */\n        /* margin-left: 21px; */\n        width: 100%;\n    }\n    .login_bg .leftBg, .login_bg .rightBg {  padding: 2rem 1rem; }\n  \n\n}\n\n@media(max-width: 320px){\n\n    .login-box .login-logo.text-left {\n        width: 100%;\n        float: left;\n        text-align: center;\n        margin-bottom: 5px;\n    }\n    .login-box .topParts .col-sm-4.text-ends {\n        width: 100%;\n        float: right;\n        text-align: center !important;\n        margin-bottom: 10px;\n    }\n    .login_bg .login-box { padding: 1rem; }\n    .login-box h2{ margin-bottom: 0; }\n    .login-box h4 {  font-size: 14px; }\n    .login-box .frgPasrd {\n        width: 100%;\n        justify-content: center;\n        display: flex;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
